module.exports = __webpack_public_path__ + "img/GD.16de5c15.svg";